import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProjectListComponent } from './components/project-list.component';
import { ProjectEditComponent } from './components/project-edit.component';
import { MsalGuard } from '@azure/msal-angular';
import { ProjectUserListComponent } from './components/project-users-list.component';

const routes: Routes = [
  { path: 'list', /*canActivate: [MsalGuard],*/ component: ProjectListComponent },
  { path: 'users', /*canActivate: [MsalGuard],*/ component: ProjectUserListComponent },
  { path: 'edit/:id', /*canActivate: [MsalGuard],*/ component: ProjectEditComponent },
  { path: 'edit', /*canActivate: [MsalGuard],*/ component: ProjectEditComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectsRoutingModule { }
